// 慎去polyfill，钉钉等有可能不支持
import 'core-js';
import 'whatwg-fetch';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './presentation/App.vue';
import AppEmbed from './presentation/AppEmbed.vue';
import router from './presentation/router';
import { startup } from './infrastructure/startup';
import { registerElementComponents } from '@/presentation/components/stdComponents';
import { getI18n } from './infrastructure/locales';
import { initTransformCodeInterceptor } from 'library-components/apis/interceptors/transform_code.interceptor';
import { E_PROJECT_NAME } from 'library-components/config/types';
import setWebsiteFont from 'library-components/utils/configure-website-font';
import { loginInitApi, checkSessionApi } from 'library-components/apis/login/login';
import { makeProxyService } from 'library-components/communicate/server';
import '@patsnap-ui/design-tokens/scss/_reboot.scss';
import 'library-components/assets/styles/el-overwrites/index.scss';
import 'library-components/assets/styles/reset.scss';
import '@/presentation/assets/styles/main.scss';
import '@/presentation/assets/styles/theme-blue.scss';
import { NormalService } from 'library-components/services/publicService';
import { ConnectService } from 'library-components/services/connectService';
import { SsoService } from 'library-components/services/ssoService';
import _ from 'lodash';
import { setTheme } from 'library-components/utils/them';
import defer from 'library-components/startup/defer';
import { CommonService } from 'library-components/services/commonService';
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import { PASSPORT_CLIENT_ID, PASSPORT_CLIENT_NAME, } from 'library-components/config/envConfig';
import { applyAuthInterceptor, applyCommonHeaderConfigInterceptor } from 'library-components/config/authInterceptor';
import { prepareTokenBase } from '@/infrastructure/startup/enable-token-base';
import { browserChecker } from 'library-components/utils/browser-checker';
import { RegisterLoginSuccessService, RegisterLoginSuccessServiceImpl } from 'library-components/services/register-login-success-service';
Vue.config.productionTip = false;
registerElementComponents();
(async () => {
    const embed = window.G_EMBED;
    const client_id = PASSPORT_CLIENT_ID;
    const from = PASSPORT_CLIENT_NAME;
    let isLogin = false;
    applyCommonHeaderConfigInterceptor();
    const sessionRes = await checkSessionApi({
        from,
        response_type: 'TOKEN',
        client_id,
        flag: from,
    });
    if (sessionRes.token) {
        isLogin = true;
        applyAuthInterceptor(sessionRes.token);
    }
    const commonService = Vue.observable(new CommonService());
    if (isLogin && commonService.IsInvitationSortCodeLink) {
        commonService.goToInvitationPage();
    }
    let passport = null;
    if (isLogin) {
        try {
            passport = await prepareTokenBase();
        }
        catch (error) {
            console.log(error);
        }
    }
    // @ts-ignore
    const [headerService, locale] = await startup({
        // @ts-ignore
        projectName: 'public',
        pageInit: [
            loginInitApi()
        ],
        zPREFACE: true,
        embed,
        isLogin,
    });
    const i18n = await getI18n(locale);
    initTransformCodeInterceptor(i18n);
    setWebsiteFont(locale);
    Vue.mixin({
        data() {
            return {
                headerService,
            };
        },
    });
    commonService.init(window.zPREFACE);
    if (embed) {
        window.iFrameResizer = {
            targetOrigin: '*',
        };
        document.body.classList.add('embed');
        import('iframe-resizer/js/iframeResizer.contentWindow');
        const proxyService = makeProxyService();
        proxyService.start();
        await proxyService.ClientReady;
        const service = new ConnectService(embed, proxyService);
        service.init(window.zPREFACE);
        const theme = service.Theme;
        setTheme(theme);
        new Vue({
            router,
            i18n,
            provide: {
                service,
                commonService,
            },
            render(h) {
                return h(AppEmbed);
            },
        }).$mount('#embed-app');
    }
    else {
        const service = Vue.observable(new NormalService(embed));
        service.init(window.zPREFACE);
        new Vue({
            router,
            i18n,
            provide: {
                service,
                commonService,
                ssoService: new SsoService(commonService),
                passport,
                [RegisterLoginSuccessService]: new RegisterLoginSuccessServiceImpl(i18n),
            },
            data() {
                return {
                    headerService,
                };
            },
            render(h) {
                return h(App, { props: { service: headerService } });
            },
        }).$mount('#public-app');
        const thirdParty = {
            lang: locale,
            sentry: {
                companyId: _.get(window, 'zPREFACE.encrypt_id'),
            },
        };
        if (!embed) {
            if (_.get(window, 'zPREFACE.region') === 'CN') {
                _.set(thirdParty, 'qiyu', {});
            }
            else {
                _.set(thirdParty, 'zendesk', {});
            }
        }
        defer(E_PROJECT_NAME.Public, {
            thirdParty,
        });
        browserChecker(i18n.locale, E_PROJECT_NAME.Public);
    }
})();
